import {
  buildPath,
  buildTemplatePath,
  CloseButton,
  Dialog,
  Divider,
  Grid,
  handleClose,
  Page,
  
  PageRoute,
  Typography,
  useParams,
} from "@compass/core";
import "moment-timezone";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

type financialTableProps = {
  languageId: number;
};

export const FinancialTablePage = ({ languageId }: financialTableProps) => {
  useEffect(() => {}, []);

  return (
    <Grid container spacing="sm">
      <Grid item xs={12}>
        <Typography>
          {languageId === 1
            ? "To start, view how many are in your household, next see where your gross income falls on how often you are paid.  If your income is below that amount you qualify for Free/Reduced Lunch and may select yes. Military personnel do not need to include housing allowance when viewing income."
            : "Por favor revisa la tabla de abajo. Para comenzar, vea cuántos hay en su hogar, luego vea dónde cae su ingreso bruto en la frecuencia con la que se les paga. El personal militar no necesita incluir el subsidio de vivienda cuando informa los ingresos."}
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Grid container spacing="sm">
          <Grid item xs={12}>
            <Grid container spacing="sm">
              <Grid item xs={2}>{languageId === 2 ? "El número de personas que residen en mi hogar" : "Household Size"}</Grid>
              <Grid item xs={2}>{languageId === 2 ? "Año" : "Yearly"}</Grid>
              <Grid item xs={2}>{languageId === 2 ? "Mes" : "Monthly"}</Grid>
              <Grid item xs={2}>{languageId === 2 ? "Dos veces por mes" : "Twice Per Month"}</Grid>
              <Grid item xs={2}>{languageId === 2 ? "Cada dos semanas" : "Every Two Weeks"}</Grid>
              <Grid item xs={2}>{languageId === 2 ? "Seminal" : "Weekly"}</Grid>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <Grid container spacing="sm">
              <Grid item xs={2}>1</Grid>
              <Grid item xs={2}>26,973</Grid>
              <Grid item xs={2}>2,248</Grid>
              <Grid item xs={2}>1,124</Grid>
              <Grid item xs={2}>1,038</Grid>
              <Grid item xs={2}>519</Grid>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <Grid container spacing="sm">
              <Grid item xs={2}>2</Grid>
              <Grid item xs={2}>36,482</Grid>
              <Grid item xs={2}>3,041</Grid>
              <Grid item xs={2}>1,521</Grid>
              <Grid item xs={2}>1,404</Grid>
              <Grid item xs={2}>702</Grid>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <Grid container spacing="sm">
              <Grid item xs={2}>3</Grid>
              <Grid item xs={2}>45,991</Grid>
              <Grid item xs={2}>3,833</Grid>
              <Grid item xs={2}>1,917</Grid>
              <Grid item xs={2}>1,769</Grid>
              <Grid item xs={2}>885</Grid>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <Grid container spacing="sm">
              <Grid item xs={2}>4</Grid>
              <Grid item xs={2}>55,500</Grid>
              <Grid item xs={2}>4,625</Grid>
              <Grid item xs={2}>2,313</Grid>
              <Grid item xs={2}>2,135</Grid>
              <Grid item xs={2}>1,068</Grid>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <Grid container spacing="sm">
              <Grid item xs={2}>5</Grid>
              <Grid item xs={2}>65,009</Grid>
              <Grid item xs={2}>5,418</Grid>
              <Grid item xs={2}>2,709</Grid>
              <Grid item xs={2}>2,501</Grid>
              <Grid item xs={2}>1,251</Grid>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <Grid container spacing="sm">
              <Grid item xs={2}>6</Grid>
              <Grid item xs={2}>74,518</Grid>
              <Grid item xs={2}>6,210</Grid>
              <Grid item xs={2}>3,105</Grid>
              <Grid item xs={2}>2,867</Grid>
              <Grid item xs={2}>1,434</Grid>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <Grid container spacing="sm">
              <Grid item xs={2}>7</Grid>
              <Grid item xs={2}>84,027</Grid>
              <Grid item xs={2}>7,003</Grid>
              <Grid item xs={2}>3,502</Grid>
              <Grid item xs={2}>3,232</Grid>
              <Grid item xs={2}>1,616</Grid>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <Grid container spacing="sm">
              <Grid item xs={2}>8</Grid>
              <Grid item xs={2}>93,536</Grid>
              <Grid item xs={2}>7,795</Grid>
              <Grid item xs={2}>3,898</Grid>
              <Grid item xs={2}>3,598</Grid>
              <Grid item xs={2}>1,799</Grid>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <Grid container spacing="sm">
              <Grid item xs={2}>{languageId === 2 ? "Cada persona adicional" : "Each additional person"}</Grid>
              <Grid item xs={2}>9,509</Grid>
              <Grid item xs={2}>793</Grid>
              <Grid item xs={2}>397</Grid>
              <Grid item xs={2}>366</Grid>
              <Grid item xs={2}>183</Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <div>
          {languageId === 1
          ? "This table is valid from July 1, 2023 to June 30, 2024. Source"
          : "Esta tabla es válida del 1 de julio de 2023 al 30 de junio de 2024. Fuente"}
          <a href="https://www.govinfo.gov/content/pkg/FR-2023-02-09/pdf/2023-02739.pdf">https://www.govinfo.gov/content/pkg/FR-2023-02-09/pdf/2023-02739.pdf</a>
        </div>
      </Grid>
    </Grid>
  );
};
